import magnifiAPIInstance from "../apiInstance";

export const v2StreamAPIs = {
  v2GetStreams: ({ payload }) => magnifiAPIInstance.get(`/api/v2/stream`, payload),
  v2GetStreamDetails: ({ streamId, payload }) => magnifiAPIInstance.get(`/api/v2/stream/${streamId}`, payload),
};
